import type { FC } from 'react';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';
import SmallTag from '@/shared/components/tags/SmallTag';

const WhitelabelUpdatedTag: FC = (): JSX.Element => {
    const { token } = useAntDesignTheme();

    return (
        <SmallTag
            compact
            dotColor={token.colorInfo}
            message='Updated'
            styles={{
                backgroundColor: token.colorInfoBg,
                border: `1px solid ${token.colorInfoBorder}`,
                color: token.colorInfoText,
            }}
        />
    );
};

export default WhitelabelUpdatedTag;
